import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { apiJson } from './apiClient';

const DamagedProductsContext = createContext({
  damaged: [],
  damagedLoading: false,
  refreshDamaged: async () => {},
});

export function DamagedProductsProvider({ children }) {
  const { user } = useAuth();
  const [damaged, setDamaged] = useState([]);
  const [damagedLoading, setDamagedLoading] = useState(false);

  const refreshDamaged = useCallback(async () => {
    if (!user) {
      setDamaged([]);
      return;
    }
    setDamagedLoading(true);
    try {
      const data = await apiJson('/damaged-products');
      setDamaged(Array.isArray(data.items) ? data.items : []);
    } catch {
      setDamaged([]);
    } finally {
      setDamagedLoading(false);
    }
  }, [user]);

  useEffect(() => {
    void refreshDamaged();
  }, [refreshDamaged]);

  return (
    <DamagedProductsContext.Provider value={{ damaged, damagedLoading, refreshDamaged }}>
      {children}
    </DamagedProductsContext.Provider>
  );
}

export function useDamagedProducts() {
  return useContext(DamagedProductsContext);
}
